/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_NoInputs */

const en_us2_intake_no = /** @type {(inputs: Intake_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const pt_br2_intake_no = /** @type {(inputs: Intake_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não`)
};

const es_419_intake_no = /** @type {(inputs: Intake_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const pt_pt2_intake_no = /** @type {(inputs: Intake_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não`)
};

const fr_fr2_intake_no = /** @type {(inputs: Intake_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non`)
};

const de_de2_intake_no = /** @type {(inputs: Intake_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein`)
};

const it_it2_intake_no = /** @type {(inputs: Intake_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {Intake_NoInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_no = /** @type {((inputs?: Intake_NoInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_NoInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_no(inputs)
	if (locale === "es-419") return es_419_intake_no(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_no(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_no(inputs)
	if (locale === "de-DE") return de_de2_intake_no(inputs)
	if (locale === "it-IT") return it_it2_intake_no(inputs)
	return en_us2_intake_no(inputs)
});
export { intake_no as "intake.no" }